import style from './CriticalErrorFallback.module.scss?module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faArrowRotateRight } from '@fortawesome/free-solid-svg-icons/faArrowRotateRight';

export function CriticalErrorFallback() {
  return (
    <div className={style.CriticalFallback}>
      <div role="alert" className={style.CriticalFallbackBox}>
        <div className="d-flex align-items-center justify-content-center gap-2">
          <h1 className={style.CriticalFallbackTitle}>
            A critical error has occurred
          </h1>
          <FontAwesomeIcon size="2xl" icon={faTriangleExclamation} bounce />
        </div>

        <p className={style.CriticalFallbackMessage}>
          The application cannot be run correctly at this time. Please reload
          the page or try again later.
        </p>

        <button
          className={style.CriticalFallbackButton}
          onClick={() => window.location.reload()}
        >
          Reload Page <FontAwesomeIcon icon={faArrowRotateRight} />
        </button>
      </div>
    </div>
  );
}
